import React from 'react'
import { findDOMNode, createPortal } from 'react-dom';
import { useState } from 'react';
import { useEffect } from 'react';
import useBSSLogger from '../../../../hooks/useBSSLogger';
import __t from '../../../../lib/traduzioni';
import { useRef } from 'react';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';
import Wrapper from '../../../Wrapper';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Whitespace from '../../../Whitespace';
import { CreditCard } from '@mui/icons-material';

const {logger} = useBSSLogger();

const Braintree = ({parametri = {}, methods, modalita}) => {

    const nodeRef = useRef();  
    const [btCfg, setBtCfg] = useState(null)
    const theme = useTheme();

    //necessario a fare il render dei componenti di stripe fuori da shadowDOM
    useEffect(()=> {
        const closestShadowBody = nodeRef?.current?.offsetParent ?? null;
        logger.debug("ottengo l'elemento di shadowdom per Braintree", closestShadowBody)
        if(closestShadowBody){
            const id = (closestShadowBody?.id ?? "").split("_")?.reverse()?.[0];
            const wrapper = document.querySelector(`section#bss_shortcode_wrapper_${id}`);
            let lightDOMSection = document.createElement("section");
            lightDOMSection.id = `bss_shortcode_wrapper_lightDOM_braintree`;
            wrapper.appendChild(lightDOMSection)            
            setBtCfg({dest: lightDOMSection})
        }
        
    }, [nodeRef])
    
    const {dest: btDest = null} = (btCfg ?? {});  
    
    return  (
        <section ref={nodeRef}>                        
            {btDest && (
                <>
                    {createPortal(                                                   
                        <section style={{
                            maxWidth: `${theme.breakpoints.values.xl}${theme.breakpoints.unit}`, 
                            margin: "auto",
                        }}>
                            <section style={{
                                paddingTop: theme.spacing(2),
                                paddingLeft: theme.spacing(6),                
                                paddingRight: theme.spacing(6),         
                            }}>
                                {/* <pre>{JSON.stringify(theme.breakpoints, null, 2)}</pre>                                 */}
                                <Braintree_ {...{parametri, methods, modalita}} />
                            </section>
                        </section>                                                                                              
                        , btDest
                    )}
                </>
                
            )}        
        </section>
        
    );

    
}

const Braintree_ = ({parametri = {}, methods, modalita}) => {

    //@todo usare i parametri reali
    parametri.authorization = "sandbox_jysdd2fd_gpvphfvsysfrcm5h";
    parametri.locale = ((navigator.language || navigator.userLanguage) ?? 'it_IT').replace(/-/g, "_");
    parametri.paypal = {flow: 'checkout', amount: '10.00', currency: 'EUR'};

    const wrapper = useRef(null);
    const [bt, setBT] = useState({instance: null});

    const {instance, createErr} = bt;

    useEffect(() => {
        logger.debug("cambio wrapper braintree", wrapper)
        const currentWrapper = wrapper?.current ?? false;
        if(currentWrapper){
            braintree?.dropin?.create?.({
                ...parametri,
                container: findDOMNode(wrapper.current)
            }, (createErr, instance) => {
                logger.debug("creazione dropin braintree", createErr, instance)
                setBT({...bt, instance, createErr})
            })
        }
        
        
        
    }, [wrapper])

    const {totalecarrello, totaleConCommissione, prezzoCommissione} = (modalita ?? {});


    return (
        <>
            <div ref={wrapper}></div>

            <Wrapper inPortal 
                containerProps={{style: {paddingLeft: "0px", paddingRight: "0px"}}} 
                paperProps={{sx: {boxShadow: "none"}}}
                shadowProps={{body: {style: {padding: "5em !important"}}}}
            > 
                {/* <pre>{JSON.stringify(theme, null, 2)}</pre> */}
                
                <Button sx={{width: "100%"}} variant="contained" >
                    <Typography variant='h6'>
                        
                        <CreditCard />                  
                        
                        <Whitespace />

                        {__t("pagaconbraintree")} 
                        
                        <>
                            <Whitespace />
                            <b>
                                {`€ ${totaleConCommissione ?? totalecarrello}`}
                            </b>
                        </>
                    
                    </Typography>                        
                </Button>  
                
                
            </Wrapper>
        </>
        
    )
}

export default Braintree